import { Alert } from "@instructure/ui-alerts";
import { t } from "i18next";

const PageNotFound = () => {
  return <Alert variant="error">{t("errorPage.notExistent")}</Alert>;
};

export default PageNotFound;
